//
//
//
//
//
//
//

export default {
  name: 'text-ellipsis',
  props: {
    text: {
      type: String,
      default: null
    },
    isShowAll: {
      // 是否展示所有
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.$refs.text2.offsetHeight > this.$refs.text1.offsetHeight) {
      this.isOverFlow = true;
    }
  },
  watch: {
    'text': function text(val) {
      var _this = this;
      this.$nextTick(function () {
        if (_this.$refs.text2.offsetHeight > _this.$refs.text1.offsetHeight) {
          _this.isOverFlow = true;
        } else {
          _this.isOverFlow = false;
        }
      });
    }
  },
  data: function data() {
    return {
      isOverFlow: false,
      isShowMore: false
    };
  },
  methods: {
    showMore: function showMore() {
      this.isShowMore = true;
    }
  }
};